<template>
    <div class="cerificateEdit">
        <div class="kmcMsgBox">
            <div class="kmcMsg">
                <div class="left">
                    <img :src="kmcMsg.coverurl" alt="">
                </div>
                <div class="right">
                    <div class="kmcname">{{kmcMsg.kmcname}}</div>
                    <div class="contentinfo">{{kmcMsg.contentinfo}}</div>
                    <div class="price">{{parseFloat(kmcMsg.saleprice) > 0 ? kmcMsg.saleprice : '免费'}}</div>
                </div>
            </div>
        </div>
        <div class="editBox padding-20 bgc box-shadow" v-if="showSet">
            <div class="left" :style="{'backgroundImage': `url(${ruleForm.certbgtype === 1 ? bgList[selectBg].sampleatturl : ruleForm.certbgurl})`}">
                <!-- 结业证书 -->
                <div class="courseCompletionCertificate" v-if="kmcMsg.qbtype !== 1">
                    <div :class="bgList[selectBg].fstylename">
                        <div class="name" :class="className">{{ruleForm.name}}</div>
                        <div class="user">
                            <img :src="user.logourl" alt="">
                            <div class="username">{{user.nickname}}</div>
                        </div>
                        <div class="text">
                            <div class="fixedText">恭喜你，完成「{{kmcMsg.kmcname}}」的学习！</div>
                            <div class="certcontent">
                                {{ruleForm.certcontent}}
                            </div>
                        </div>
                        <div class="codeShare">
                            <div class="code">
                                <img v-if="ruleForm.qrcodeurl" :src="ruleForm.qrcodeurl + '?' + time" alt="">
                            </div>
                            <div class="share">{{ruleForm.sharecontent}}</div>
                        </div>
                    </div>
                </div>
                <!-- 分值证书 -->
                <div class="scoreCertificate" v-else>
                    <div :class="bgList[selectBg].fstylename">
                        <div class="name" :class="className">{{ruleForm.name}}</div>
                        <div class="user">
                            <img :src="user.logourl" alt="">
                            <div class="username">{{user.nickname}}</div>
                        </div>
                        <div class="text">
                            <div class="fixedText">在「{{kmcMsg.kmcname}}」获得</div>
                            <div class="score">
                                <span>90</span>
                                分
                            </div>
                            <div class="certcontent">
                                必须记住我们学习的时间有限的。时间有限，不只由于人生短促，更由于人事纷繁。
                            </div>
                        </div>
                        <div class="codeShare">
                            <div class="code">
                                <img v-if="ruleForm.qrcodeurl" :src="ruleForm.qrcodeurl + '?' + time" alt="">
                            </div>
                            <div class="share">{{ruleForm.sharecontent}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
                    <el-form-item label="证书名称" prop="name" class="name required">
                        <el-input placeholder="请输入证书名称" :disabled="disabled" v-model="ruleForm.name" maxlength="10" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="考试成绩" prop="minexamscore" v-if="kmcMsg.qbtype === 1" class="minexamscore required">
                        大于等于
                        <el-input v-model="ruleForm.minexamscore" :disabled="disabled"></el-input>
                        分
                        <span class="tips">（当前试卷总分为<span>{{Number(kmcMsg.examtotalscore)}}</span>分）</span>
                    </el-form-item>
                    <el-form-item label="证书背景" class="required certbg">
                        <p class="tips">证书图片建议尺寸 750*1334px 或 9:16，jpg/png 格式，大小不超过 2MB</p>
                        <p class="view" @click="openExample">查看示例图</p>
                        <UploadFile :checkDisabled="disabled" :uploadType="uploadImageType" @setFile="setBgFile" :fileRule="bgfileRule"></UploadFile>
                        <div class="bgList">
                            <div class="bgitem" v-for="(item, index) in bgList" :key="index">
                                <img :src="require('@/common/images/certificate/select.png')" class="select" v-if="index === selectBg" alt="">
                                <img :src="item.sampleatturl" @click="selectBgItem(index)" :class="{'sampleatturl': true, 'active': index === selectBg}" alt="">
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="得分设置" v-if="kmcMsg.qbtype === 1" class="required scoreSet">
                        <div class="setBox">
                            <div class="titleBox">
                                <div class="leftBox">得分范围</div>
                                <div class="centerBox">点评内容</div>
                                <div class="rightBox">操作</div>
                            </div>
                            <div class="scoreItem" v-for="(item, index) in ruleForm.scorecontent" :key="index">
                                <div class="show" v-if="!item.show">
                                    <div class="score">{{item.minpoints}}-{{item.maxpoints}}</div>
                                    <div class="content">{{item.content}}</div>
                                    <div class="handle">
                                        <span class="editBtn" @click="editItem(index)">编辑</span>
                                        <span class="line">|</span>
                                        <span class="deleteBtn" @click="deleteItem(index)">删除</span>
                                    </div>
                                </div>
                                <div class="edit" v-else>
                                    <div class="points">
                                        <div class="itemName">得分范围</div>
                                        <div class="value">
                                            <el-input v-model="item.minpoints"></el-input>
                                            <span class="connect">-</span>
                                            <el-input v-model="item.maxpoints"></el-input>
                                            <span class="unit">分</span>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div class="itemName">点评内容</div>
                                        <div class="value">
                                            <el-input v-model="item.content" type="textarea" placeholder="请输入点评内容，不超过50个字" maxlength="50" show-word-limit></el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="add" @click="addScoreItem"><img :src="require('@/common/images/certificate/add.png')" alt=""> 添加点评</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="二维码" prop="qrcodeurl" class="required">
                        <div class="code">
                            <div class="left">
                                <div class="defaultImg" v-if="!ruleForm.qrcodeurl">
                                    <i class="el-icon-picture"></i>
                                </div>
                                <img :src="ruleForm.qrcodeurl + '?' + time" v-else class="qrcodeurl" alt="">
                            </div>
                            <div class="right">
                                <UploadFile :checkDisabled="disabled" :uploadType="uploadImageType" @setFile="setCodeFile" :fileRule="fileRule"></UploadFile>
                                <p class="tips">点击上传图片，建议尺寸750*750px的正方形二维码图片，您可选取公众号二维码等，jpg/png格式，图片小于1MB</p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="点评内容" prop="certcontent" class="certcontent required" v-if="kmcMsg.qbtype !== 1">
                        <el-input type="textarea" :disabled="disabled" placeholder="请输入点评内容" v-model="ruleForm.certcontent" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="分享语" prop="sharecontent" class="sharecontent required">
                        <el-input placeholder="请输入分享语" :disabled="disabled" v-model="ruleForm.sharecontent" maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="btnBox">
            <el-button class="cancel" @click="cancel">取消</el-button>
            <el-button type="primary" v-if="!disabled" @click="submit">提交</el-button>
        </div>
        <exampleDialog ref="exampleDialog" />
    </div>
</template>
<script>
import {getCertKMCDetail, getCertinfoDetail, getCertBgList, saveOrUpdateCertinfo} from 'api/operateToolApi'
import {mapActions, mapGetters} from 'vuex'
import UploadFile from 'base/upload/uploadFile2'
import {computeFileSize} from 'common/js/tools'
import exampleDialog from './certificate/component/exampleDialog'
export default {
    name: 'cerificateedit',
    data() {
        const checkminexamscore = (rule, value, callback) => {
            if (value !== '') {
                console.log(value)
                if (parseFloat(value) > parseFloat(this.kmcMsg.examtotalscore)) {
                    callback(new Error('考试成绩不能大于总成绩'))
                } else {
                    callback()
                }
            } else {
                callback(new Error('请输入考试成绩'))
            }
        }
        const checkscorecontent = (rule, value, callback) => {
            if (!this.ruleForm.scorecontent.length) {
                callback(new Error('请进行得分设置'))
            } else {
                let flag = true
                this.ruleForm.scorecontent.some((item, index) => {
                    if (item.minpoints === '' || item.maxpoints === '' || item.content === '') {
                        flag = false
                        return false
                    }
                })
                if (!flag) {
                    callback(new Error('请完善得分设置'))
                } else {
                    callback()
                }
            }
        }
        return {
            params: this.$route.query,
            kmcMsg: {},
            bgList: [],
            selectBg: 0,
            ruleForm: {
                certtype: '',
                name: '',
                kmcinnerid: this.$route.query.kmcinnerid,
                kmctype: Number(this.$route.query.kmctype),
                minexamscore: '',
                certbgtype: 1,
                certbgid: '',
                certbgurl: '',
                certcontent: '必须记住我们学习的时间有限的。时间有限，不只由于人生短促，更由于人事纷繁。',
                scorecontent: [],
                sharecontent: '我已参与本课程学习，快来和我一起参与吧！',
                qrcodeid: '',
                qrcodeurl: ''
            },
            rules: {
                name: [
                    {required: true, message: '请输入证书名称', trigger: 'blur'}
                ],
                minexamscore: [
                    {required: true, message: '请输入考试成绩', trigger: 'blur'},
                    {validator: checkminexamscore, trigger: 'blur'}
                ],
                certcontent: [
                    {required: true, message: '请输入点评内容', trigger: 'blur'}
                ],
                sharecontent: [
                    {required: true, message: '请输入分享语', trigger: 'blur'}
                ],
                qrcodeurl: [
                    {required: true, message: '请上传二维码', trigger: 'blur'}
                ],
                scorecontent: [
                    {validator: checkscorecontent, trigger: 'blur'}
                ]
            },
            showSet: false,
            uploadImageType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            fileRule: {
                btnName: '选择二维码',
                cls: '',
                accept: '.jpg,.png',
                size: 1,
                width: '750',
                height: '750',
                nottype: true
            },
            bgfileRule: {
                btnName: '上传背景',
                cls: '',
                accept: '.jpg,.png',
                size: 2,
                width: '750',
                height: '1334',
                nottype: true
            },
            time: new Date().getTime(),
            disabled: false
        }
    },
    created() {
        if (!this.params.innerid) {
            this.getCertKMCDetail()
        } else {
            this.getCertinfoDetail()
        }
    },
    methods: {
        submit() {
            this.$refs.ruleForm.validate((valid, errlist) => {
                if (valid) {
                    if (this.kmcMsg.qbtype === 1) {
                        if (!this.ruleForm.scorecontent.length) {
                            this.$message.error('请进行得分设置')
                            return
                        }
                        let flag = true
                        this.ruleForm.scorecontent.some((item, index) => {
                            if (item.minpoints === '' || item.maxpoints === '' || item.content === '') {
                                this.$message.error('请完善得分设置')
                                flag = false
                                return false
                            } else if (parseFloat(item.minpoints) >= parseFloat(item.maxpoints)) {
                                this.$message.error('请正确进行得分设置')
                                flag = false
                                return false
                            }
                        })
                        if (!flag) {
                            return
                        }
                    }
                    if (this.ruleForm.certbgtype === 1) {
                        this.ruleForm.certbgid = this.bgList[this.selectBg].bginnerid
                    }
                    if (this.ruleForm.certtype === 1) {
                        this.ruleForm.minexamscore = 0
                    }
                    let ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
                    if (ruleForm.scorecontent) {
                        ruleForm.scorecontent.forEach((item, index) => {
                            delete item.show
                        })
                        ruleForm.scorecontent = JSON.stringify(ruleForm.scorecontent)
                    }
                    this.setLoading(true)
                    saveOrUpdateCertinfo({
                        data: ruleForm,
                        success: res => {
                            this.setLoading(false)
                            this.$message.success('设置成功')
                            this.$router.back(1)
                            console.log(res)
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                    console.log(this.ruleForm)
                } else {
                    for(let key in errlist) {
                        this.$message.error(errlist[key][0].message)
                        return
                    }
                }
            })
        },
        openExample() {
            this.$refs.exampleDialog.open(this.ruleForm.certtype)
        },
        addScoreItem() {
            this.ruleForm.scorecontent.forEach((obj, index) => {
                obj.show = false
            })
            let item = {
                minpoints: '', maxpoints: '', content: '', show: true
            }
            this.ruleForm.scorecontent.push(item)
        },
        editItem(index) {
            if (!this.disabled) {
                this.ruleForm.scorecontent.forEach((obj, index) => {
                    obj.show = false
                })
                this.ruleForm.scorecontent[index].show = true
            }
        },
        deleteItem(index) {
            if (!this.disabled) {
                this.ruleForm.scorecontent.splice(index, 1)
            }
        },
        cancel() {
            this.$router.back(1)
        },
        setBgFile(file) {
            computeFileSize()
            this.ruleForm.certbgid = file.key
            this.ruleForm.certbgurl = file.furl
            this.ruleForm.certbgtype = 2
            this.selectBg = -1
            this.time = new Date().getTime()
        },
        setCodeFile(file) {
            computeFileSize()
            console.log(file)
            this.ruleForm.qrcodeid = file.key
            this.ruleForm.qrcodeurl = file.furl
            this.$refs.ruleForm.validateField('qrcodeurl')
            this.time = new Date().getTime()
        },
        selectBgItem(index) {
            this.selectBg = index
            console.log(index)
        },
        // 获取证书关联的媒资详情
        getCertKMCDetail() {
            this.setLoading(true)
            getCertKMCDetail({
                data: this.params,
                success: res => {
                    this.setLoading(false)
                    if (res.data.qbtype === 1) {
                        this.ruleForm.certtype = 2
                        this.getCertBgList(2)
                    } else {
                        this.ruleForm.certtype = 1
                        this.getCertBgList(1)
                    }
                    this.kmcMsg = res.data
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取证书背景列表
        getCertBgList(certtype) {
            this.setLoading(true)
            getCertBgList({
                data: {certtype},
                success: res => {
                    this.setLoading(false)
                    this.bgList = res.data
                    this.showSet = true
                    console.log(this.bgList)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取证书详情
        getCertinfoDetail() {
            this.setLoading(true)
            getCertinfoDetail({
                data: {innerid: this.params.innerid},
                success: res => {
                    this.setLoading(false)
                    this.kmcMsg = res.data.kmcinfo
                    this.bgList = res.data.certbginfo
                    res.data.certbginfo.some((obj, index) => {
                        if (obj.certbginnerid === res.data.certinfo.certbginnerid) {
                            this.selectBg = index
                            return true
                        }
                    })
                    res.data.certinfo.kmcinnerid = res.data.kmcinfo.kmcinnerid
                    res.data.certinfo.kmctype = res.data.kmcinfo.kmctype
                    this.ruleForm = res.data.certinfo
                    this.showSet = true
                    if (this.ruleForm.status === 0) {
                        this.disabled = true
                    }
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        className() {
            if (this.selectBg === 0) {
                return 'name0'
            } else if (this.selectBg === 1) {
                return 'name1'
            } else if (this.selectBg === 2) {
                return 'name2'
            } else if (this.selectBg === 3) {
                return 'name3'
            } else if (this.selectBg === 4) {
                return 'name4'
            } else if (this.selectBg === 5) {
                return 'name5'
            }
        },
        ...mapGetters([
            'user'
        ])
    },
    components: {
        UploadFile,
        exampleDialog
    }
}
</script>
<style lang="scss">
    .cerificateEdit {
        .kmcMsgBox {
            padding: 20px;
            background: #fff;
            margin-bottom: 24px;
            .kmcMsg {
                background: #FAFAFA;
                display: flex;
                align-items: center;
                padding: 22px 20px;
                .left {
                    width: 180px;
                    height: 102px;
                    margin-right: 30px;
                    img {
                        width: 180px;
                        height: 102px;
                    }
                }
                .right {
                    height: 102px;
                    .kmcname {
                        font-size: 16px;
                        font-weight: bold;
                        line-height: 22px;
                        margin-bottom: 12px;
                    }
                    .contentinfo {
                        color: #606266;
                        font-size: 14px;
                        margin-bottom: 12px;
                    }
                    .price {
                        color: #FF4747;
                        font-size: 14px;
                    }
                }
            }
        }
        .editBox {
            display: flex;
            .left {
                width: 375px;
                height: 666px;
                margin-right: 36px;
                background-size: 100%;
                position: relative;
                .courseCompletionCertificate {
                    .name {
                        position: absolute;
                        width: 100%;
                        text-align: center;
                        font-size: 24px;
                        font-weight: bold;
                    }
                    .user {
                        position: absolute;
                        width: 100%;
                        text-align: center;
                        img {
                            width: 64px;
                            height: 64px;
                            border-radius: 50%;
                            margin-bottom: 12px;
                        }
                        .username {
                            font-size: 18px;
                            font-weight: bold;
                            line-height: 25px;
                        }
                    }
                    .text {
                        position: absolute;
                        text-align: center;
                        width: 100%;
                    }
                    .fixedText {
                        padding: 0 50px;
                        font-size: 14px;
                        line-height: 24px;
                        box-sizing: border-box;
                    }
                    .certcontent {
                        padding: 0 32px;
                        font-size: 14px;
                        line-height: 24px;
                        text-align: center;
                        box-sizing: border-box;
                    }
                    .codeShare {
                        position: absolute;
                        width: 100%;
                        display: flex;
                        .code {
                            width: 59px;
                            height: 59px;
                            margin-right: 12px;
                            img {
                                width: 59px;
                                height: 59px;
                            }
                        }
                        .share {
                            width: 120px;
                            font-size: 12px;
                            line-height: 20px;
                        }
                    }
                    .style2 {
                        .name {
                            top: 115px
                        }
                        .user {
                            top: 163px;
                        }
                        .text {
                            top: 290px;
                        }
                        .certcontent {
                            margin-top: 50px;
                        }
                        .codeShare {
                            bottom: 42px;
                            padding-left: 93px;
                            .share {
                                // color: #036D3A;
                            }
                        }
                    }
                    .style1 {
                        .name {
                            top: 30px;
                        }
                        .user {
                            top: 83px;
                        }
                        .text {
                            top: 214px;
                        }
                        .certcontent {
                            margin-top: 30px;
                        }
                        .codeShare {
                            bottom: 15px;
                            padding-left: 93px;
                            .share {
                                color: #fff;
                            }
                        }
                    }
                    .style3 {
                        .name {
                            top: 115px;
                        }
                        .user {
                            top: 163px;
                        }
                        .text {
                            top: 290px;
                        }
                        .certcontent {
                            margin-top: 50px;
                        }
                        .codeShare {
                            bottom: 16px;
                            padding-left: 93px;
                            .share {
                                color: #FFFFFF;
                            }
                        }
                    }
                }
                .scoreCertificate {
                    .name {
                        position: absolute;
                        width: 100%;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                    }
                    .user {
                        position: absolute;
                        width: 100%;
                        text-align: center;
                        img {
                            width: 45px;
                            height: 45px;
                            border-radius: 50%;
                            margin-bottom: 12px;
                        }
                        .username {
                            font-size: 18px;
                            font-weight: bold;
                            line-height: 25px;
                        }
                    }
                    .text {
                        position: absolute;
                        text-align: center;
                        width: 100%;
                    }
                    .fixedText {
                        padding: 0 50px;
                        font-size: 16px;
                        line-height: 24px;
                    }
                    .score {
                        padding: 0 50px;
                        width: 100%;
                        box-sizing: border-box;
                        text-align: center;
                        font-size: 14px;
                        font-weight: bold;
                        span {
                            font-size: 30px;
                        }
                    }
                    .certcontent {
                        font-size: 14px;
                        line-height: 24px;
                        text-align: center;
                        width: 100%;
                        box-sizing: border-box;
                    }
                    .codeShare {
                        position: absolute;
                        width: 100%;
                        display: flex;
                        .code {
                            width: 59px;
                            height: 59px;
                            margin-right: 12px;
                            img {
                                width: 59px;
                                height: 59px;
                            }
                        }
                        .share {
                            width: 120px;
                            font-size: 12px;
                            line-height: 20px;
                        }
                    }
                    .style11 {
                        .name {
                            top: 34px;
                            font-size: 20px;
                        }
                        .user {
                            top: 83px;
                        }
                        .text {
                            top: 170px;
                        }
                        .score {
                            margin-top: 25px;
                        }
                        .certcontent {
                            padding: 0 50px;
                            margin-top: 15px;
                        }
                        .codeShare {
                            bottom: 15px;
                            padding-left: 93px;
                            .share {
                                color: #fff;
                            }
                        }
                    }
                    .style12 {
                        .name {
                            top: 115px;
                            font-size: 24px;
                        }
                        .user {
                            top: 163px;
                        }
                        .text {
                            top: 254px;
                        }
                        .score {
                            margin-top: 20px;
                        }
                        .certcontent {
                            padding: 0 32px;
                            margin-top: 25px;
                            font-size: 16px;
                        }
                        .codeShare {
                            bottom: 42px;
                            padding-left: 93px;
                        }
                    }
                    .style13 {
                        .name {
                            top: 115px;
                            font-size: 24px;
                        }
                        .user {
                            top: 163px;
                        }
                        .text {
                            top: 254px;
                        }
                        .score {
                            margin-top: 20px;
                        }
                        .certcontent {
                            padding: 0 32px;
                            margin-top: 25px;
                            font-size: 16px;
                        }
                        .codeShare {
                            bottom: 16px;
                            padding-left: 93px;
                            .share {
                                color: #fff;
                            }
                        }
                    }
                }
                .name0 {
                    color: #036D3A;
                }
                .name1 {
                    color: #BB3135;
                }
                .name2 {
                    color: #024288;
                }
                .name3 {
                    color:#EC5E69;
                }
                .name4 {
                    color: #036D3A;
                }
                .name5 {
                    color: #EC5E69;
                }
            }
            .right {
                .el-form {
                    .el-form-item__label {
                        text-align: left;
                    }
                    .el-form-item__content {
                        margin-left: 100px !important;
                    }
                    .name {
                        .el-input {
                            width: 526px;
                            height: 32px;
                        }
                    }
                    .minexamscore {
                        .el-input {
                            width: 90px;
                            margin: 0 8px;
                        }
                        .tips {
                            color: #999999;
                            font-size: 14px;
                            span {
                                color: #EC5E69;
                            }
                        }
                    }
                    .certbg {
                        .tips {
                            font-size: 14px;
                            color: #C0C4CC;
                            margin-bottom: 8px;
                            line-height: 18px;
                            margin-top: 12px;
                        }
                        .view {
                            color: #409EFF;
                            cursor: pointer;
                            margin-bottom: 4px;
                            line-height: 18px;
                        }
                        .bgList {
                            padding-top: 20px;
                            display: flex;
                            align-items: center;
                            .bgitem {
                                height: 70px;
                                margin-right: 24px;
                                position: relative;
                                box-sizing: border-box;
                                .sampleatturl {
                                    width: 38px;
                                    height: 69px;
                                    cursor: pointer;
                                    &.active {
                                        border: 1px solid #409EFF;
                                    }
                                }
                                .select {
                                    width: 18px;
                                    height: 18px;
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                }
                            }
                            
                        }
                    }
                    .scoreSet {
                        .setBox {
                            border: 1px solid #DCDFE6;
                            width: 538px;
                            .titleBox {
                                display: flex;
                                align-items: center;
                                background: #FAFAFA;
                                border-bottom: 1px solid #DCDFE6;
                                padding: 0 20px;
                                box-sizing: border-box;
                                font-size: 14px;
                                .leftBox {
                                    flex: 1;
                                }
                                .centerBox {
                                    width: 266px;
                                    text-align: center;
                                }
                                .rightBox {
                                    flex: 1;
                                    text-align: right;
                                }
                            }
                            .scoreItem {
                                border-bottom: 1px solid #DCDFE6;
                                .show {
                                    padding: 10px 20px;
                                    display: flex;
                                    align-items: center;
                                    height: 40px;
                                    line-height: 20px;
                                    box-sizing: border-box;
                                    .score {
                                        flex: 1;
                                    }
                                    .content {
                                        width: 266px;
                                        text-align: center;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                    .handle {
                                        flex: 1;
                                    }
                                    .handle {
                                        text-align: right;
                                        color: #439FFE;
                                        .line {
                                            margin: 0 10px;
                                        }
                                        .editBtn, .deleteBtn {
                                            cursor: pointer;
                                        }
                                    }
                                }
                                .edit {
                                    padding: 20px 20px 0;
                                    .points {
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 20px;
                                        height: 32px;
                                        .itemName {
                                            margin-right: 20px;
                                            font-size: 14px;
                                            position: relative;
                                            top: 3px;
                                            &::after {
                                                content: '*';
                                                color: #F56C6C;
                                            }
                                        }
                                        .value {
                                            display: flex;
                                            align-items: center;
                                            .el-input {
                                                width: 90px;
                                            }
                                            .connect {
                                                margin: 0 10px;
                                                position: relative;
                                                top: 3px;
                                            }
                                            .unit {
                                                margin-left: 10px;
                                                position: relative;
                                                top: 3px;
                                            }
                                        }
                                    }
                                    .content {
                                        display: flex;
                                        margin-bottom: 20px;
                                        .itemName {
                                            margin-right: 20px;
                                            font-size: 14px;
                                            line-height: 18px;
                                            &::after {
                                                content: '*';
                                                color: #F56C6C;
                                            }
                                        }
                                        .value {
                                            .el-textarea {
                                                width: 414px;
                                                height: 120px;
                                                .el-textarea__inner {
                                                    height: 120px;
                                                    resize: none;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            .add {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #439FFE;
                                font-size: 14px;
                                height: 40px;
                                cursor: pointer;
                                img {
                                    width: 12px;
                                    height: 12px;
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                    .code {
                        display: flex;
                        align-items: center;
                        .left {
                            width: 110px;
                            height: 110px;
                            margin-right: 14px;
                            text-align: center;
                            line-height: 110px;
                            .defaultImg {
                                background: #F5F7FA;
                                .el-icon-picture {
                                    color: #DCDFE6;
                                    font-size: 40px;
                                }
                            }
                            .qrcodeurl {
                                width: 110px;
                                height: 110px;
                            }
                        }
                        .right {
                            .tips {
                                width: 394px;
                                line-height: 18px;
                                color: #C0C4CC;
                                font-size: 14px;
                            }
                        }
                    }
                    .certcontent {
                        padding-top: 4px;
                        .el-textarea {
                            height: 102px;
                            width: 526px;
                            .el-textarea__inner {
                                resize: none;
                                height: 102px;
                            }
                        }
                    }
                    .required {
                        .el-form-item__label::before {
                            display: none;
                        }
                        .el-form-item__label::after {
                            content: '*';
                            color: #F56C6C;
                            margin-left: 4px;
                        }
                    }
                }
            }
        }
        .btnBox {
            margin-top: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            padding: 20px;
            .cancel {
                margin-right: 32px;
            }
        }
    }
</style>